import * as React from 'react'
import { Helmet } from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'
import SmallLogoImage from '../assets/logo.jpeg'

const Seo = ({ description = '', lang = 'en', meta = [], title }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
          }
        }
      }
    `
  )

  const metaDescription = `India's best Nintendo Games Reseller`
  const defaultTitle = 'NI Store India'

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title="Ni Store"
      defaultTitle={defaultTitle}
      titleTemplate={defaultTitle ? `%s | ${title}` : null}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          name: `image`,
          content: '../assets/logo.jpeg',
        },
        {
          property: `og:title`,
          content: 'NI Store ',
        },
        {
          property: `og:description`,
          content: `India's best Nintendo Games Reseller`,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:image`,
          content: '../assets/logo.jpeg',
        },
        {
          name: `twitter:card`,
          content: `summary_large_image`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata?.social?.twitter || ``,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    >
      <link
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.13.0/css/all.min.css"
        rel="stylesheet"
      />
      <script async src="https://www.googletagmanager.com/gtag/js?id=G-GEL4P9QDBC"></script>
      <script dangerouslySetInnerHTML={{
        __html: `  
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', 'G-GEL4P9QDBC');`
      }}></script>
    </Helmet>
  )
}

export default Seo
